// extracted by mini-css-extract-plugin
module.exports = {"ImageBox":"Image_ImageBox__vs2Vn","Image":"Image_Image__1w_Nu","Type":"Image_Type__3q44z"};